import { z } from 'zod';
// ─── Enums ──────────────────────────────────────────────────────────────────
export const MediaSourceTypeSchema = z.enum([
    'uploaded',
    'extracted',
    'searched',
    'generated',
]);
export const MediaTypeSchema = z.enum(['image', 'video', 'audio']);
export const MediaRoleSchema = z.enum([
    'primary_image',
    'audio',
    'supplementary',
]);
export const UsageScopeSchema = z.enum(['global', 'course', 'user']);
// ─── Attribution ────────────────────────────────────────────────────────────
export const MediaAttributionSchema = z.object({
    required: z.boolean(),
    name: z.string().nullable(),
    nameUrl: z.string().url().nullable(),
    source: z.string().nullable(),
    sourceUrl: z.string().url().nullable(),
});
// ─── API Response Shapes ────────────────────────────────────────────────────
/** Single media item as returned by the API (after signing). */
export const MediaItemSchema = z.object({
    id: z.string().uuid(),
    url: z.string(),
    path: z.string(),
    type: MediaTypeSchema,
    filename: z.string(),
    size: z.number().int().nonnegative().nullable(),
    mimeType: z.string(),
    role: MediaRoleSchema,
    sourceType: MediaSourceTypeSchema,
    attribution: MediaAttributionSchema.nullable(),
    qualityScore: z.number().min(0).max(1).nullable(),
});
/** Full media record as returned by admin/detailed endpoints. */
export const MediaRecordSchema = MediaItemSchema.extend({
    sourceProvider: z.string().nullable(),
    sourceId: z.string().nullable(),
    sourceUrl: z.string().nullable(),
    licenceSpdx: z.string().nullable(),
    licenceUrl: z.string().nullable(),
    commercialUseAllowed: z.boolean().nullable(),
    modificationAllowed: z.boolean().nullable(),
    usageScope: UsageScopeSchema,
    reusable: z.boolean(),
    createdBy: z.string().uuid().nullable(),
    createdAt: z.string(),
});
//# sourceMappingURL=media.schema.js.map